import { get_user_profile } from "@/router";

export default {
  name: "WelcomeBack",

  data() {
    return ({
      full_name: "Guest User",
    });
  },

  mounted() {
    this.load_user_name();
  },

  methods: {
    load_user_name() {
      const userProfile = get_user_profile();

      if (userProfile && (userProfile.first_name || userProfile.last_name)) {
        this.full_name = `${userProfile.first_name || ''} ${userProfile.last_name || ''}`.trim();
      } else {
        const first_name = sessionStorage.getItem("first_name") || "";
        const last_name = sessionStorage.getItem("last_name") || "";
        this.full_name = `${first_name} ${last_name}`.trim() || "Guest User";
      }

      if (this.full_name === "Guest User" && userProfile?.email) {
        this.full_name = userProfile.email.split("@")[0];
      }
    },
  },
};
